<template>
  <div>
    <div>
      <div class="head-topbar lite-page-top linebottom sticky">
        <div class="topbar-left" @click="goto('/my')"><i class="icon-arrow-left"></i></div>
        <div class="topbar-main"><h4>关于嘉盛云平台</h4></div>
      </div>
      <div class="aboutPage">
        <div class="content">
          <p>
            嘉盛云平台是为追思和纪念已故亲友，举行线上祭拜仪式的平台，用户可为已故亲友创建线上纪念馆，可以线上祭拜、留言，寄托对逝者的思念和祝福，也便后人、亲友流传和纪念。
          </p>
          <p>&nbsp;</p>

          <p>&nbsp;</p>
          <p>为防止入口丢失，请先关注嘉盛云平台公众号。</p>
          <p>&nbsp;</p>
          <p style="text-align: center;">
            <img src="../../../assets/ft2.jpg" alt="" width="167" height="167" />
          </p>
          <p style="text-align: center;">识别二维码关注</p>
          <p style="text-align: center;">&nbsp;</p>
          <p style="text-align: center;">&nbsp;</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'agreement',
  data() {
    return {}
  },
  methods: {
    goto(str) {
      this.$router.push({ path: str })
    },
  },
  created() {},
  watch: {},
}
</script>

<style>
.head-topbar.sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}
.head-topbar {
  display: flex;
  align-items: center;
  height: 3.8rem;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 1;
}
.head-topbar .topbar-left {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.73333vw;
  position: absolute;
  left: 0.265rem;
  height: 100%;
  z-index: 10;
}
.head-topbar .topbar-left .icon-arrow-left {
  background: url(../../../assets/jnt/zjt1.png) no-repeat;
  background-size: 100%;
  display: inline-block;
  height: 1.363rem;
  width: 0.818rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.head-topbar .topbar-main {
  flex: 1;
  color: #333;
  font-size: 1.454rem;
}

.aboutPage {
  padding: 20px 15px;
}

.aboutPage .title {
  color: #333;
  font-size: 1.4rem;
}
.aboutPage .content {
  border-radius: 10px;
  background: #fff;
  padding: 10px;
  margin-top: 10px;
  font-size: 1.3rem;
  line-height: 2.2rem;
}
.weui-cells {
  margin-top: 1.17647059em;
  background-color: #fff;
  line-height: 1.41176471;
  font-size: 17px;
  overflow: hidden;
  position: relative;
}
.weui-cell {
  padding: 15px;
  position: relative;
  display: flex;
  align-items: center;
}
.weui-cell__bd {
  flex: 1;
}
.text-center {
  text-align: center;
}
.weui-cells:after,
.weui-cells:before {
  content: ' ';
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  color: #e5e5e5;
}
.weui-cells:before {
  top: 0;
  border-top: 1px solid #e5e5e5;
  transform-origin: 0 0;
  transform: scaleY(0.5);
}
.weui-cells:after {
  bottom: 0;
  transform-origin: 0 100%;
  transform: scaleY(0.5);
}
.weui-cells:after,
.weui-cells:before {
  content: ' ';
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  color: #e5e5e5;
}
.head-topbar.sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}
.head-topbar {
  display: flex;
  align-items: center;
  height: 3.8rem;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 1;
}
.dashedlinebottom,
.dashedlinetop,
.linebottom,
.lineright,
.linetop {
  position: relative;
  -webkit-box-sizing: border-box;
  padding: 0;
}
.head-topbar .topbar-left {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.73333vw;
  position: absolute;
  left: 0.265rem;
  height: 100%;
  z-index: 10;
}

.head-topbar .topbar-left .icon-arrow-left {
  background: url(../../../assets/jnt/left1.png) no-repeat;
  background-size: 100%;
  display: inline-block;
  height: 1.363rem;
  width: 0.818rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.head-topbar .topbar-main {
  flex: 1;
  color: #333;
  font-size: 1.454rem;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: 400;
}
.head-topbar .topbar-right {
  padding-right: 1rem;
  position: absolute;
  right: 0.265rem;
  font-size: 1.272rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
